import { render, staticRenderFns } from "./QuestionExample.vue?vue&type=template&id=54833823&scoped=true&"
import script from "./QuestionExample.vue?vue&type=script&lang=js&"
export * from "./QuestionExample.vue?vue&type=script&lang=js&"
import style0 from "./QuestionExample.vue?vue&type=style&index=0&id=54833823&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54833823",
  null
  
)

export default component.exports